import { render, staticRenderFns } from "./uploadBidding.vue?vue&type=template&id=5fb04bce&"
import script from "./uploadBidding.vue?vue&type=script&lang=js&"
export * from "./uploadBidding.vue?vue&type=script&lang=js&"
import style0 from "./uploadBidding.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports